import { jsx as _jsx } from "react/jsx-runtime";
import { clearFilter, FilterType, ShowtimeFilterKey } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { Message } from '../../message/message';
export var ShowtimePickerMessageType;
(function (ShowtimePickerMessageType) {
    ShowtimePickerMessageType["NoCinemasSelected"] = "NoCinemasSelected";
    ShowtimePickerMessageType["NoShowtimesForFilter"] = "NoShowtimesForFilter";
    ShowtimePickerMessageType["NoShowtimesAllDates"] = "NoShowtimesAllDates";
    ShowtimePickerMessageType["NoShowtimesForFilmOnDate"] = "NoShowtimesForFilmOnDate";
    ShowtimePickerMessageType["NoShowtimesForSitesOnDate"] = "NoShowtimesForSitesOnDate";
    ShowtimePickerMessageType["FailedToLoadData"] = "FailedToLoadData";
})(ShowtimePickerMessageType || (ShowtimePickerMessageType = {}));
const b = bemClassBuilder('v-showtime-picker-message');
export const ShowtimePickerMessage = observer(props => {
    const i18n = useI18n();
    const { displayText, config, assets, messageType, actionButton, messageFilmTitle } = props;
    return (_jsx(Message, Object.assign({}, getShowtimePickerMessageProps(messageType, assets, displayText, i18n, messageFilmTitle), { className: b.block() }, { children: getActionButton(messageType, displayText, config, actionButton) })));
});
ShowtimePickerMessage.displayName = 'ShowtimePickerMessage';
const getShowtimePickerMessageProps = (messageType, assets, displayText, i18n, selectedFilmTitle) => {
    switch (messageType) {
        case ShowtimePickerMessageType.NoCinemasSelected:
            return {
                iconName: assets.noSitesSelectedIconName,
                title: displayText.noSitesSelectedTitle,
                description: displayText.noSitesSelectedMessage
            };
        case ShowtimePickerMessageType.NoShowtimesAllDates:
            return {
                iconName: assets.noShowtimesIconName,
                title: displayText.noShowtimesForAnyDateTitle,
                description: displayText.noShowtimesForAnyDateMessage
            };
        case ShowtimePickerMessageType.NoShowtimesForFilter:
            return { iconName: assets.noShowtimesIconName, description: displayText.noShowtimesForFilterMessage };
        case ShowtimePickerMessageType.NoShowtimesForFilmOnDate:
            return {
                iconName: assets.noShowtimesIconName,
                description: selectedFilmTitle
                    ? getFormattedMessage(displayText.noShowtimesForFilmMessage, selectedFilmTitle, i18n)
                    : displayText.noShowtimesGenericMessage
            };
        case ShowtimePickerMessageType.NoShowtimesForSitesOnDate:
            return { iconName: assets.noShowtimesIconName, description: displayText.noShowtimesGenericMessage };
        case ShowtimePickerMessageType.FailedToLoadData:
            return {
                iconName: assets.failedToLoadDataIconName,
                title: displayText.failedToLoadDataTitle,
                description: displayText.failedToLoadDataMessage
            };
        default:
            return undefined;
    }
};
const getActionButton = (messageType, displayText, config, actionButton) => {
    var _a;
    const filterId = (_a = config.filter) === null || _a === void 0 ? void 0 : _a.filterId;
    if (messageType === ShowtimePickerMessageType.NoShowtimesForFilter && filterId) {
        return (_jsx("p", Object.assign({ className: b.element('clear-button'), onClick: () => handleClearButtonClicked(filterId) }, { children: displayText.noShowtimesForFilterClearButtonLabel })));
    }
    return config.actionButton.show && actionButton;
};
const handleClearButtonClicked = (filterId) => {
    clearFilter({ id: filterId, type: FilterType.Showtime, keys: Object.values(ShowtimeFilterKey) });
};
const getFormattedMessage = (template, selectedFilmTitle, i18n) => {
    return i18n.template(template, {
        selectedFilmTitle: i18n.translatable(selectedFilmTitle)
    });
};
